module.exports = __webpack_public_path__ + "static/media/check-off.1fed5e9a.svg";